import ApiGateway from '../../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
export const batchPut = async (params) => {
    let res = { err: null, data: null };
    debug && console.log('batchPut params', params);
    const path = `/batch/put`;
    const apiRes = (await ApiGateway.post(path, params, 'ConsumerApi'));
    debug && console.log('getGraphQueryRequestV2 apiRes', apiRes);
    res =
        apiRes; /** Note to consumers, this lambda may return partial data as well as an error when operation has been aborted for some reason. Retry with data.UnprocessedItems as params.Items */
    console.log(res);
    return res;
};
